<div class="card">
  <div class="card-body" #contentDiv>
    <blockquote class="blockquote bq-success">
      <p class="bq-title">
        {{ Localization.YourAccountHasBeenSuccessfullyCreated | translate}}!
      </p>
      <p class="bq-title">
        {{ Localization.LoginInTheChappsMaintenanceOrganizer | translate }}
      </p>
      <div class="row justify-content-center mt-3">
        <button class="btn btn-amber" mdbRippleRadius (click)="goToAccountPage()">
          {{ Localization.GoToLoginPage | translate}}
        </button>
      </div>
    </blockquote>
  </div>
</div>

